import { Component, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription, finalize, take } from 'rxjs';

import { LoadingService } from '../../../loading/loading.service';
import { ISortState } from './link-user.interface';
import { ModalController } from '@ionic/angular';
import { EntitiesService } from 'src/app/modules/services/entities/entities.service';
import { UserService } from 'src/app/modules/services/user/user.service';
import { CreateRoleModalComponent } from '../../../roles/create-role-modal/create-role-modal.component';
import { ToastService } from 'src/app/modules/services/toast/toast.service';
import { RoleService } from 'src/app/modules/services/role/roles.service';

@Component({
  selector: 'app-link-user-modal',
  templateUrl: './link-user-modal.component.html',
  styleUrls: ['./link-user-modal.component.scss'],
})
export class LinkUserModalComponent {
  @Input() idEntity: string | null = null;
  @Input() data: any;
  entityName: string = '';
  entityId: string = '';
  filteredUsers: any[] = [];
  filteredRoles: any[] = [];
  subscriptions: Subscription[] = [];
  form: FormGroup;
  selectedUser: any = null;
  selectedRole: any = null;
  allUsersFromEntity: any[] = [];
  canSubmit: boolean = false;

  sortState: ISortState = { sortProperty: 'nomeUsuario', sortDirection: 'asc' };
  pageSize: number = 10;
  pageIndex: number = 0;
  totalPages: number = 1;
  totalElements: number = 0;
  displayedColumns: string[] = ['nome', 'cargo', 'removeAction'];

  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  buttonInclusaoDisabled:boolean = false;
  buttonExclusaoDisabled:boolean = false;
  disabledTooltipMessage: string = 'Ação não permitida';
  constructor(
    private fb: FormBuilder,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private entityService: EntitiesService,
    private userService: UserService,
    private roleService: RoleService,
    private modalCtrl: ModalController
  ) {

  
 
    this.form = this.fb.group({
      userFilterInput: [''],
      roleFilterInput: [''],
      nameOrRoleSearchTerm: [''],
    });
  }

  ngOnInit(): void {
    this.dataSource.paginator = this.paginator;
    if (this.idEntity) {
      this.loadEntityData(this.idEntity);
    }
    if(this.data){
      this.buttonExclusaoDisabled = this.data.buttonExclusaoDisabled;
      this.buttonInclusaoDisabled = this.data.buttonInclusaoDisabled;
    }
  }

  loadEntityData(idEntity: string) {
    this.loadingService.showLoading();

    this.subscriptions.push(
      this.entityService
        .getEntityWithLinkedData(idEntity)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe(
          (response: any) => {
            this.dataSource.data = response.usuarios;
            this.allUsersFromEntity = response.usuarios;
            this.entityName = response.razaoSocial;
            this.entityId = response.idEntidade;
            this.setPaginatorValues();
          },
          (erro) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
    );
  }

  onSortChange(sortProperty: 'nomeUsuario' | 'nomeCargo') {
    if (this.sortState.sortProperty === sortProperty) {
      this.sortState.sortDirection =
        this.sortState.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortState.sortProperty = sortProperty;
      this.sortState.sortDirection = 'asc';
    }

    const sortedUsers = this.dataSource.data.sort((a, b) => {
      let comparison = 0;
      if (a[sortProperty] > b[sortProperty]) {
        comparison = 1;
      } else if (a[sortProperty] < b[sortProperty]) {
        comparison = -1;
      }

      return this.sortState.sortDirection === 'asc' ? comparison : -comparison;
    });

    this.dataSource.data = sortedUsers;
  }

  onSortChangeKeydown(
    event: KeyboardEvent,
    sortProperty: 'nomeUsuario' | 'nomeCargo'
  ) {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
      this.onSortChange(sortProperty);
    }
  }

  removeUser(id: string) {
    const updatedProfileUsers = this.dataSource.data.filter(
      (user) => user.idUsuario !== id
    );
    this.dataSource.data = updatedProfileUsers;
    this.allUsersFromEntity = updatedProfileUsers;
    this.canSubmit = true;
    this.setPaginatorValues();
  }

  removeUserKeydown(event: KeyboardEvent, id: string) {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
      this.removeUser(id);
    }
  }

  setPaginatorValues() {
    this.totalElements = this.dataSource.data.length;
    this.totalPages = Number(
      (1 + this.totalElements / this.pageSize).toPrecision(1)
    );
  }

  onUserSearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.selectedUser = null;

    if (filterValue.length >= 3 || filterValue.length === 0) {
      this.searchUsers(filterValue);
    }
  }

  searchUsers(searchTerm: string) {
    if (!searchTerm) {
      return (this.filteredUsers = []);
    }

    return this.subscriptions.push(
      this.userService
        .getUsers(0, 500, 'asc', 'nome', searchTerm, 'true')
        .pipe(take(1))
        .subscribe(
          (response: any) => {
            this.filteredUsers = response.content;
          },
          (erro) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
    );
  }

  selectUser(user: any) {
    this.selectedUser = user;
    this.form.patchValue({ userFilterInput: user.nome });
    this.filteredUsers = [];
  }

  keydownSelectUser(event: KeyboardEvent, user: any) {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
      this.selectUser(user);
    }
  }

  onRoleSearch(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.selectedRole = null;

    this.searchRoles(filterValue);
  }

  searchRoles(searchTerm: string) {
    if (!searchTerm) {
      return (this.filteredRoles = []);
    }

    return this.subscriptions.push(
      this.roleService
        .getRoles(searchTerm)
        .pipe(take(1))
        .subscribe(
          (response: any) => {
            this.filteredRoles = response.content.map((role: any) => ({
              id: role.id,
              nomeCargo: role.nome,
            }));
          },
          (erro: any) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
    );
  }

  selectRole(role: any) {
    this.selectedRole = role;
    this.form.patchValue({ roleFilterInput: role.nomeCargo });
    this.filteredRoles = [];
  }

  keydownSelectRole(event: KeyboardEvent, role: any) {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
      this.selectRole(role);
    }
  }

  onAddSelectedUser() {
    if (!this.selectedUser || !this.selectedRole) {
      return this.toastService.showError('Selecione um usuário e um cargo.');
    }

    if (
      this.allUsersFromEntity.findIndex(
        (u) => u.idUsuario === this.selectedUser.id
      ) >= 0
    ) {
      return this.toastService.showError(
        `O usuário "${this.selectedUser?.nome}" já está vinculado.`
      );
    }

    const userIndex = this.dataSource.data.findIndex(
      (u) => u.id === this.selectedUser.id
    );
    if (userIndex < 0) {
      let users = this.dataSource.data;
      const newUser = {
        idUsuario: this.selectedUser.id,
        nomeUsuario: this.selectedUser.nome,
        idCargo: this.selectedRole.id,
        nomeCargo: this.selectedRole.nomeCargo,
      };
      users.push(newUser);
      this.dataSource.data = users;
      this.allUsersFromEntity = users;
    }

    this.setPaginatorValues();

    this.form.patchValue({ userFilterInput: '', roleFilterInput: '' });
    this.selectedUser = null;
    this.selectedRole = null;
    this.canSubmit = true;
  }

  async openNewRoleDialog(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: CreateRoleModalComponent,
      backdropDismiss: false,
      cssClass: 'modal-sm',
    });
    modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {
      this.selectRole(data);
    }
  }

  async keydownOpenNewRoleDialog(event: KeyboardEvent) {
    if (
      event.key === 'Spacebar' ||
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      event.preventDefault();
      await this.openNewRoleDialog();
    }
  }

  applyUserFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.data = this.allUsersFromEntity;

    if (filterValue) {
      let filteredUsers = this.dataSource.data;
      const lowerCaseSearchTerm = filterValue.toLowerCase();

      this.dataSource.data = filteredUsers.filter(
        (user) =>
          user.nomeUsuario.toLowerCase().includes(lowerCaseSearchTerm) ||
          user.nomeCargo.toLowerCase().includes(lowerCaseSearchTerm)
      );
    }

    this.setPaginatorValues();
  }

  canShowCreateRoleOption() {
    return (
      this.filteredRoles.length === 0 &&
      this.form.get('roleFilterInput')?.value !== '' &&
      !this.selectedRole
    );
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  onSubmit() {
    this.loadingService.showLoading();

    const formData = {
      idEntidade: this.entityId,
      usuarios: this.dataSource.data,
    };

    return this.subscriptions.push(
      this.entityService
        .linkUsersToEntity(formData)
        .pipe(
          take(1),
          finalize(() => {
            this.loadingService.hideLoading();
          })
        )
        .subscribe(
          (response: any) => {
            this.toastService.showSuccess(response.message);
            return this.modalCtrl.dismiss(null, 'confirm');
          },
          (erro) => {
            if (erro.status !== 500 && erro.status) {
              this.toastService.showError(erro.error.message);
            } else {
              this.toastService.showError();
            }
          }
        )
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
